// core version + navigation, pagination modules:
//import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// swiper core styles
import 'swiper/css/bundle';

import './top-section-swiper.scss';

const wrapper = document.querySelector('.full-height-top-section .swiper');

new Swiper(wrapper, {
    // Optional parameters
    //modules: [Navigation, Pagination, EffectFade, Autoplay],
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    autoplay: true,
    speed: 800,
    //effect: "fade",
    //fadeEffect: {
    //  crossFade: true
    //},
    navigation: {
        prevEl: wrapper.querySelector('.swiper--prev-btn'),
        nextEl: wrapper.querySelector('.swiper--next-btn')
    },
    pagination: {
      el: wrapper.querySelector('.swiper-pagination'),
      clickable: true,
    },
});